import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { get_task_assignment } from "../../services/projectApi";
import CustomModal from "../../components/UiComponent/Modal";
import EmpTaskAssignmentForm from "./EmpTaskAssignmentForm";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import BasicTable from "../../components/UiComponent/customTable";
import { GrView } from "react-icons/gr";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";
const TaskAssignment = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = GetUserInfo();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };

  const getempTaskAssignmentQuery = useQuery(["getempTaskAssignment"], () =>
    get_task_assignment()
  );
  const assignmentData = useMemo(() => {
    return getempTaskAssignmentQuery.data || [];
  }, [getempTaskAssignmentQuery.data]);

  if (getempTaskAssignmentQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getempTaskAssignmentQuery.isError) {
    return <div>Error: {getempTaskAssignmentQuery.error.message}</div>;
  }

  const addNewempTasKAssignment = (event, id) => {
    event.preventDefault();
    handleShowModal();
  };

  const handleViewProject = (projectId) => {
    history.push("/task-view", { projectId });
  };
  const projectColumns = [
    {
      header: "name",
      accessor: "task_name",
      accessorKey: "task_name",
      cell: (row) => (
        <div className="data-content">
          <p className="m-0 text-secondary small">
            {row.row.original.task_name}
          </p>
        </div>
      ),
    },
    {
      header: "Total Branches",
      accessorKey: "branches_assigned",
    },

    {
      header: "Total Workers",
      accessorKey: "workers_assigned",
    },
    {
      header: "Active Workers",
      accessorKey: "active_assignments",
    },
    {
      header: "action",
      accessor: "id",
      cell: (row) =>
        hasAccess(["administrator"], user.accessRole) ? (
          <Button
            variant="btn btn-sm m-2"
            size="sm"
            onClick={() => handleViewProject(row.row.original.task_id)}
          >
            <GrView />
          </Button>
        ) : (
          ""
        ),
    },
  ];

  return (
    <div>
      <BasicTable
        data={assignmentData}
        columns={projectColumns}
        title={`task_assignment_list`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => addNewempTasKAssignment(e, "id")}
          >
            {t("add_new_assignment")}
          </Button>
        }
      />
      <CustomModal
        show={showModal}
        title="new_task_assignment"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <EmpTaskAssignmentForm
            onSubmitButton={handleButtonSubmit}
            parentID={"id"}
          />
        }
      />
    </div>
  );
};
export default TaskAssignment;
